import React from "react";

function UserHeader({
  name,
  setSidebarOpen
}) {

  return (

    <header className="dashboard-header">

      {/* ================= LEFT ================= */}

      <div className="header-left">

        {/* MOBILE MENU */}

        <button
          type="button"
          className="mobile-menu-btn"
          onClick={() => setSidebarOpen(true)}
        >
          <i className="bi bi-list"></i>
        </button>


        {/* SEARCH */}

        <div className="dashboard-search">

          <i className="bi bi-search"></i>

          <input
            type="text"
            placeholder="Search MCQs, tests, subjects..."
          />

        </div>

      </div>


      {/* ================= RIGHT ================= */}

      <div className="header-right">

        {/* NOTIFICATION */}

        <button
          type="button"
          className="notification-btn"
          aria-label="Notifications"
        >

          <i className="bi bi-bell"></i>

          <span></span>

        </button>


        {/* USER */}

        <div className="user-profile">

          {/* AVATAR */}

          <div className="user-avatar">

            {name
              ? name.charAt(0).toUpperCase()
              : "S"}

          </div>


          {/* USER INFO */}

          <div className="user-info">

            <strong>
              {name || "Student"}
            </strong>

            <small>
              Student
            </small>

          </div>

        </div>

      </div>

    </header>

  );
}

export default UserHeader;

